import Email from "@/domain/entities/emails/Email";
import CategoryBadge from "./CategoryBadge";

type CategoriesListProps = {
    mail: Email;
    className?: string;
};

const CategoriesList = ({ mail, className }: CategoriesListProps) => (
    <div className={`flex shrink-0 items-center gap-1.5 ${className}`}>
        {mail.aiDetails?.categories.slice(0, 2).map(
            (
                category, // TODO: remove slice when SDK will anly send 2 categories
            ) => (
                <div key={`${category} ${mail.id}`}>
                    <CategoryBadge
                        key={`${category} ${mail.id}`}
                        category={category}
                    />
                </div>
            ),
        )}
    </div>
);

export default CategoriesList;
